// extracted by mini-css-extract-plugin
export var description = "headerSection-module--description--1ecd3";
export var title = "headerSection-module--title--a244d";
export var wrapper = "headerSection-module--wrapper--19aae";